import { createFileRoute } from "@tanstack/react-router";
import { getGitHubConnection } from "@/features/identity/records";
import { githubConnectSearchSchema } from "@/features/identity/navigation";
import { GitHubConnectPage } from "@/features/identity";
import { VerifiedSession } from "@/session/product-session";

export const Route = createFileRoute("/_site/github/connect")({
  validateSearch: githubConnectSearchSchema,
  loaderDeps: ({ search }) => search,
  loader: ({ deps, abortController }) =>
    getGitHubConnection({ data: deps, signal: abortController.signal }),
  gcTime: 0,
  head: () => ({
    meta: [
      { title: "Connect GitHub repositories | Softmax" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: GitHubConnectRoute,
});

function GitHubConnectRoute() {
  const data = Route.useLoaderData();
  return (
    <VerifiedSession sessionUserId={data.sessionUserId}>
      <GitHubConnectPage key={data.sessionUserId} {...data} />
    </VerifiedSession>
  );
}
